const Main = resolve => require(['@/components/main/Main.vue'], resolve);
const App = resolve => require(['@/App.vue'], resolve);

//配件申请
const PartApplyList = resolve => require(['@/module/partsApply/list.vue'], resolve);
const PartApplyEdit = resolve => require(['@/module/partsApply/edit.vue'], resolve);
const PartApplyDetail = resolve => require(['@/module/partsApply/detail.vue'], resolve);

//公告管理
const NoticeList = resolve => require(['@/module/notice/noticeList.vue'], resolve);
const NoticeView = resolve => require(['@/module/notice/noticeView.vue'], resolve);

export default [
  //配件申请模块
  {
    path: '/partsApply',
    component: Main,
    children: [{
        path: 'list',
        name: 'partsApply-list',
        component: PartApplyList,
        meta: {
          keepAlive: true
        }
      },
      {
        path: 'create/',
        name: 'partsApply-create',
        component: PartApplyEdit
      },
      {
        path: 'edit/:id',
        name: 'partsApply-edit',
        component: PartApplyEdit
      },
      {
        path: 'detailcreate/:partid',
        name: 'partsApply-detailcreate',
        component: PartApplyDetail
      },
      {
        path: 'detailedit/:id',
        name: 'partsApply-detailedit',
        meta: {
          keepAlive: true
        },
        component: PartApplyDetail
      }
    ]
  },
  {
    path: "/notice",
    component: Main,
    children: [{
        path: "list",
        name: "NoticeList",
        component: NoticeList
      },
      {
        path: "view/:id",
        name: "NoticeView",
        component: NoticeView
      }
    ]
  },
  {
    path: '/crmpartsApply',
    component: App,
    children: [{
      path: 'list',
      name: 'crm__partsApply-list',
      component: PartApplyList
    }]
  },
  {
    path: '/crmnotice',
    component: App,
    children: [{
      path: 'list',
      name: 'crm__noticeList',
      component: NoticeList
    }]
  },
]



// WEBPACK FOOTER //
// ./src/module/router.js